var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotifications = function SvgNotifications(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Group 459",
    viewBox: "0 0 40.815 36"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "notifications_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h40.815v36H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#notifications_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 36V6.176c.327.231.582.4.825.585q8.735 6.624 17.46 13.261A3.305 3.305 0 0 0 22.848 20c5.709-4.6 11.469-9.149 17.211-13.714.219-.175.448-.337.755-.566V36ZM2.341.38q8.953 6.86 17.9 13.729c.436.336.672.188 1.006-.08Q29.807 7.244 38.379.474A3 3 0 0 1 38.907.2l-.182-.2H1.906c.238.209.331.3.433.376"
  }))));
};
export default SvgNotifications;